import React from "react";
import ReactDOM from "react-dom/client";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { FluentProvider } from "@fluentui/react-components";
import App from "./App";
import { ThemeProvider, useThemeMode } from "./contexts/ThemeContext";
import "./index.css";

function ThemedApp({ msalInstance }) {
    const { theme } = useThemeMode();
    return <FluentProvider theme={theme}><App msalInstance={msalInstance} /></FluentProvider>;
}

function start() {
    const msalInstance = new PublicClientApplication({
        auth: {
            clientId: process.env.REACT_APP_CLIENT_ID,
            authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
            redirectUri: "/",
        },
    });
    msalInstance.addEventCallback(event => {
        if (event.eventType === EventType.LOGIN_SUCCESS) msalInstance.setActiveAccount(event.payload.account);
    });
    ReactDOM.createRoot(document.getElementById("root")).render(
        <React.StrictMode><ThemeProvider><ThemedApp msalInstance={msalInstance} /></ThemeProvider></React.StrictMode>
    );
}

try {
    start();
} catch (error) {
    console.error("EzFunc failed to start:", error);
    document.getElementById("root").textContent = "EzFunc could not start. Check the app configuration and reload.";
}
